import { Pagination } from 'react-bootstrap';
import './style.scss';

// standard pagination component for switching between pages and adjusting size
export default function PaginationPageSizeWidget({
  totalPages,
  totalItems,
  currentItemsCount,
  handleChangePageNo,
  currentPageNo,
  currentPageSize,
  handleChangePageSize,
  showPageSizeChanger,
}) {
  return (
    <>
      <div className="d-md-none text-center d-block pb-4">
        Showing {currentItemsCount} out of {totalItems} records
      </div>
      <div
        className={
          'd-flex flex-column flex-md-row justify-content-between' +
          ' align-items-center gap-3'
        }
      >
        <Pagination>
          <Pagination.First />
          <Pagination.Prev />
          {totalPages > 1 &&
            Array.from({ length: totalPages }, (_, i) => {
              let farFromCur = Math.abs(currentPageNo - (i + 1));

              if (farFromCur > 3) {
                return null;
              }
              if (farFromCur === 3) {
                return <Pagination.Ellipsis key={i} />;
              }

              return (
                <Pagination.Item
                  key={i}
                  active={currentPageNo === i + 1}
                  onClick={() => {
                    handleChangePageNo(i + 1);
                  }}
                >
                  <span
                    className={
                      currentPageNo === i + 1 ? '' : 'custom-page-link'
                    }
                  >
                    {i + 1}
                  </span>
                </Pagination.Item>
              );
            })}
          <Pagination.Next />
          <Pagination.Last />
        </Pagination>
        <div className="d-none d-md-block">
          Showing {currentItemsCount} out of {totalItems} records
        </div>
        {showPageSizeChanger && (
          <div>
            <span>Records per page</span>{' '}
            <select
              defaultValue={currentPageSize}
              onChange={(e) => {
                handleChangePageSize(e.target.value);
              }}
              className="form-control-sm"
            >
              {[5, 20, 50, 75, 100].map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </>
  );
}
